import { Checkbox, Text, VisuallyHidden } from '@vtex/admin-ui'
import { FormState, useWatch } from '@vtex/admin-ui-form'
import { FormattedMessage, useIntl } from 'react-intl'
import { IconNotification } from '../../../../../icons'
import { messages } from './messages'
import { styles } from './styles'

type NotificationHeaderProps = {
  name: string
  form: FormState
}

export function NotificationHeader(props: NotificationHeaderProps) {
  const { name, form } = props
  const { $t } = useIntl()

  const enable: boolean = useWatch({ form, name: `${name}.enable` })

  return (
    <>
      <div className={styles.leftCluster}>
        <div className={styles.iconBox}>
          <IconNotification />
        </div>
        <div className={styles.textColumn}>
          <Text variant="body">
            <FormattedMessage {...messages.title} />
          </Text>
          <Text tone="secondary" variant="detail">
            <FormattedMessage {...messages.description} />
          </Text>
        </div>
      </div>
      <Checkbox
        checked={enable}
        label={<VisuallyHidden>{$t(messages.checkboxAria)}</VisuallyHidden>}
      />
    </>
  )
}
